import React from "react";
import {
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Basicdetailsclicked from "../../../assets/images/Basicdetailsclicked.png";
import sanctionclicked from "../../../assets/images/sanctionclicked.png";
import tickicon from "../../../assets/images/tickicon.png";
import incomeclicked from "../../../assets/images/incomeclicked.png";
import loandetailsclicked from "../../../assets/images/loandetailsclicked.png";
import disbursalclicked from "../../../assets/images/disbursalclicked.png";
import income from "../../../assets/images/income.png";
import basicdetails from "../../../assets/images/basicdetails.png";
import kyc from "../../../assets/images/kyc.png";
import sanction from "../../../assets/images/sanction.png";
import kycclicked from "../../../assets/images/kycclicked.png";
import disbursal from "../../../assets/images/dibursal.png";
import loan from "../../../assets/images/loan.png"; 
export default function TabNavigation(props) {
  const {
    status,
    handleToggle,
    handleMandateDetails,
    isImageClicked1,
    isImageClicked2,
    isImageClicked3,
    isImageClicked4,
    isImageClicked5,
    isImageClicked6,
    bankSelfieData
  } = props;
  return (
    <>
      {status === "Disbursed" ? (
        <Nav
          className="navProfile"
          style={{
            listStyleType: "none",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginRight: "50px",
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          {/* <p style={{padding:'0.6em',color:'black',borderRight:'2px solid black',borderRadius:'0.2em',background:'orange',fontWeight:'500'}}>Application Progress</p>  */}

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("1")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked1 ? Basicdetailsclicked : basicdetails}
                alt="basicdetails"
              />
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked1 ? "#D32027" : "black",
                }}
              >
                Basic Details
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>
          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => handleToggle("2")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked2 ? kycclicked : kyc}
                alt="kyc"
              />
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>

              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked2 ? "#D32027" : "black",
                }}
              >
                KYC
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                marginRight: "10px",
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("3")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked3 ? incomeclicked : income}
                alt="income"
              />
              {/* <div style={{marginTop:"10px",borderStyle:"solid",borderColor:"#F8A31F",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center"}}></div> */}
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked3 ? "#D32027" : "black",
                }}
              >
                Income & CIBIL
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => {
                handleToggle("4");
                handleMandateDetails(
                  bankSelfieData ? bankSelfieData.razorpayDetails : null
                );
              }}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked4 ? sanctionclicked : sanction}
                alt="sanction"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked4 ? "#D32027" : "black",
                }}
              >
                Sanction
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("5")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked5 ? disbursalclicked : disbursal}
                alt="disbursal"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked5 ? "#D32027" : "black",
                }}
              >
                Disbursal
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("6")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked6 ? loandetailsclicked : loan}
                alt="loan"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked6 ? "#D32027" : "black",
                }}
              >
                Loan Details
              </p>
            </NavLink>
          </NavItem>
        </Nav>
      ) : (
        <Nav
          className="navProfile"
          style={{
            listStyleType: "none",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginRight: "50px",
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          {/* <p style={{padding:'0.6em',color:'black',borderRight:'2px solid black',borderRadius:'0.2em',background:'orange',fontWeight:'500'}}>Application Progress</p>  */}

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("1")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked1 ? Basicdetailsclicked : basicdetails}
                alt="basicdetails"
              />
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked1 ? "#D32027" : "black",
                }}
              >
                Basic Details
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>
          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => handleToggle("2")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked2 ? kycclicked : kyc}
                alt="kyc"
              />
              <div style={{ marginTop: "10px" }}>
                <img
                  style={{
                    padding: "3px",
                    borderStyle: "solid",
                    borderColor: "#12B76A",
                    borderRadius: "50%",
                    height: "24px",
                    width: "24px",
                    alignSelf: "center",
                    backgroundColor: "#12B76A",
                  }}
                  alt=""
                  src={tickicon}
                />
              </div>

              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked2 ? "#D32027" : "black",
                }}
              >
                KYC
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              alignSelf: "center",
              height: "3px",
              width: "80px",
              background: "#12B76A",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                marginRight: "10px",
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("3")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked3 ? incomeclicked : income}
                alt="income"
              />
              <div
                style={{
                  marginTop: "10px",
                  borderStyle: "solid",
                  borderColor: "#F8A31F",
                  borderRadius: "50%",
                  height: "24px",
                  width: "24px",
                  alignSelf: "center",
                }}
              ></div>
              {/* <div style={{marginTop:"10px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked3 ? "#D32027" : "black",
                }}
              >
                Income & CIBIL
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              borderBottom: "3px dashed #F8A31F",
              borderSpacing: "40px",
              alignSelf: "center",
              height: "3px",
              width: "80px",
              marginRight: "10px",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => {
                handleToggle("4");
                handleMandateDetails(
                  bankSelfieData ? bankSelfieData.razorpayDetails : null
                );
              }}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked4 ? sanctionclicked : sanction}
                alt="sanction"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div
                style={{
                  marginTop: "10px",
                  borderStyle: "solid",
                  borderColor: "#CFCFCF",
                  borderRadius: "50%",
                  height: "24px",
                  width: "24px",
                  alignSelf: "center",
                }}
              ></div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked4 ? "#D32027" : "black",
                }}
              >
                Sanction
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              borderBottom: "3px solid #CFCFCF",
              borderSpacing: "40px",
              alignSelf: "center",
              height: "3px",
              width: "80px",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("5")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked5 ? disbursalclicked : disbursal}
                alt="disbursal"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div
                style={{
                  marginTop: "10px",
                  borderStyle: "solid",
                  borderColor: "#CFCFCF",
                  borderRadius: "50%",
                  height: "24px",
                  width: "24px",
                  alignSelf: "center",
                }}
              ></div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked5 ? "#D32027" : "black",
                }}
              >
                Disbursal
              </p>
            </NavLink>
          </NavItem>
          <div
            style={{
              borderBottom: "3px solid #CFCFCF",
              borderSpacing: "40px",
              alignSelf: "center",
              height: "3px",
              width: "80px",
            }}
          ></div>

          <NavItem style={{ display: "flex", flexDirection: "column" }}>
            <NavLink
              style={{
                fontWeight: "500",
                fontSize: "15px",
                color: "black",
                cursor: "pointer",
                lineHeight: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
              onClick={() => handleToggle("6")}
            >
              <img
                style={{ height: "40px", width: "40px" }}
                src={isImageClicked6 ? loandetailsclicked : loan}
                alt="loan"
              />
              {/* <div style={{marginTop:"20px"}}><img style={{borderStyle:"solid",borderColor:"#12B76A",borderRadius:"50%",height:"24px",width:"24px",alignSelf:"center",backgroundColor:'#12B76A'}} src={tickicon}/></div> */}
              <div
                style={{
                  marginTop: "10px",
                  borderStyle: "solid",
                  borderColor: "#CFCFCF",
                  borderRadius: "50%",
                  height: "22px",
                  width: "22px",
                  alignSelf: "center",
                }}
              ></div>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  marginTop: "10px",
                  color: isImageClicked6 ? "#D32027" : "black",
                }}
              >
                Loan Details
              </p>
            </NavLink>
          </NavItem>
        </Nav>
      )}
    </>
  );
}
